const cache = {};

export const setRecommendationCache = (key, value) => {
  cache[key] = value;
};

export const getRecommendationCache = (key) => {
  if (typeof key === 'string') {
    return cache[key];
  }
  return undefined;
};
